import script from "./ExamInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamInfo.vue?vue&type=script&setup=true&lang=js"

import "./ExamInfo.vue?vue&type=style&index=0&id=b31dc954&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/mgtpr6vc/mgt-elearning/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b31dc954"]])

export default __exports__